const resizer = (width = 375) => {
	if (/(iPhone\sOS)\s([\d_]+)/.test(navigator.userAgent)) {
		document.documentElement.style.fontSize = `${(document.documentElement
			.clientWidth /
			width) *
			16}px`;
	} else {
		document.documentElement.style.fontSize = `${(window.innerWidth /
			width) *
			16}px`;
	}
};
export default resizer;
